module.exports = __webpack_public_path__ + "img/Evert_van_de Werfhorst.cc34b667.jpg";